module.exports = __webpack_public_path__ + "static/header-img-5eb79d77536a8d6c0edc13cd5812529e.png";